module.exports = [{"image":"Flag_Blank.svg","name":"","type":"square"},{"image":"Flag_Blank.svg","name":"","type":"square"},{"image":"Flag_Blank.svg","name":"","type":"square"},{"image":"Flag_Blank.svg","name":"","type":"square"},{"image":"Flag_Blank.svg","name":"","type":"square"},{"image":"Flag_Blank.svg","name":"","type":"square"},{"image":"Flag_Blank.svg","name":"","type":"square"}]


//////////////////
// WEBPACK FOOTER
// ./public/data/blank-legend.json
// module id = 34Mg
// module chunks = 1